<script lang="ts">
    import { onDestroy } from "svelte";

    import { randomNum } from "../utils/common";
    import AppBar from "./AppBar.svelte";

    let showCursor = false;
    const index = randomNum(0, 2);

    const interval = setInterval(() => {
        showCursor = !showCursor;
    }, 800);

    onDestroy(() => clearInterval(interval));
</script>

<div class="root-container">
    <AppBar minimal />
    <img
        class="not-found-img"
        src={`img/404-${index}.png`}
        alt="Page not found"
    />

    <div class="not-found-container">
        <span class="not-found-title">
            404
            {#if showCursor}
                <span>&#x258A;</span>
            {/if}
        </span>

        <span class="not-found-text">Page not found.</span>
    </div>
</div>

<style lang="scss">
    .not-found-img {
        border-radius: 4rem;
        width: 256px;
    }

    .root-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2rem;
    }

    .not-found-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .not-found-title {
        width: 4rem;
        height: 3rem;
        font-family: monospace;
        font-size: 38px;
        color: #72f270;
        text-shadow: 0px 0px 2px #72f270;
        display: flex;
    }

    .not-found-text {
        font-size: 16px;
        font-family: monospace;
        color: #72f270;
        text-shadow: 0px 0px 2px #72f270;
    }
</style>
